import { Outlet, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import LassoToggleButtons from "../../../components/LassoToggleButtons";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

type Views = "chart" | "table";

const DashboardLayout = () => {
    const navigate = useNavigate();

    const [ headerText, setHeaderText ] = useState<string>("");
    const [ view, setView ] = useState<Views>("chart");
    const [ previousLocation, setPreviousLocation ] = useState<Location>();
    return (
        <Stack height={"calc(100% - 16px)"} marginX="24px" marginBottom={"16px"} gap={3}>
            <Stack flexDirection={"row"} alignItems={"center"} gap={4}>
                {previousLocation && (
                    <Button
                        variant="contained"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate(previousLocation)}
                    >
                        Back to main Dashboard
                    </Button>
                )}
                <Typography fontSize={"32px"} fontWeight={"600"}>{headerText}</Typography>
                <LassoToggleButtons
                    sx={{
                        marginLeft: 'auto'
                    }}
                    value={view}
                    onChange={(e, newValue) => {
                        if (newValue) {
                            setView(newValue)
                        }
                    }}
                    exclusive
                    buttons={[
                        { label: "Chart View", value: "chart", minWidth: '200px' },
                        { label: "Table View", value: "table", minWidth: '200px' }
                    ]}
                />
            </Stack>
            <Outlet
                context={{
                    setHeaderText: setHeaderText,
                    setPreviousLocation: setPreviousLocation,
                    view: view
                }}
            />
        </Stack>
    )
}

export default DashboardLayout;